import { createTranslations } from '@npco/utils-translations'

export const productDisplayT2Translation = createTranslations({
  new: 'New {description}',
  posLite: 'POS Lite built-in',
})
